import { render, staticRenderFns } from "./FormulationProductMappingPopup.vue?vue&type=template&id=127d7328&scoped=true&"
import script from "./FormulationProductMappingPopup.vue?vue&type=script&lang=js&"
export * from "./FormulationProductMappingPopup.vue?vue&type=script&lang=js&"
import style0 from "./FormulationProductMappingPopup.vue?vue&type=style&index=0&id=127d7328&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "127d7328",
  null
  
)

export default component.exports